import { useIntlModule } from 'utils/intl/useIntlModule';
import messages from './tutorials.intl.json';

export function useTutorialsIntl() {
  return useIntlModule(messages);
}
